"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _States = _interopRequireDefault(require("../States"));
var _RecentCalls = _interopRequireDefault(require("../../CRM/Dialer/RecentCalls"));
var _OperatorsDropdown = _interopRequireDefault(require("../../CRM/Dialer/OperatorsDropdown"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DefaultState = /*#__PURE__*/function (_React$Component) {
  function DefaultState() {
    (0, _classCallCheck2["default"])(this, DefaultState);
    return _callSuper(this, DefaultState, arguments);
  }
  (0, _inherits2["default"])(DefaultState, _React$Component);
  return (0, _createClass2["default"])(DefaultState, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        calls = _this$props.calls,
        onCall = _this$props.onCall,
        onListen = _this$props.onListen,
        onOperatorsToggle = _this$props.onOperatorsToggle,
        onRecentCallsToggle = _this$props.onRecentCallsToggle,
        operators = _this$props.operators,
        state = _this$props.state;
      return /*#__PURE__*/_react["default"].createElement(StyledDefaultState, this.props, /*#__PURE__*/_react["default"].createElement(StyledCaller, {
        calls: calls,
        onCall: onCall,
        onToggle: onRecentCallsToggle
      }), /*#__PURE__*/_react["default"].createElement(_OperatorsDropdown["default"], {
        state: state,
        onCall: onCall,
        onListen: onListen,
        onToggle: onOperatorsToggle,
        operators: operators
      }));
    }
  }]);
}(_react["default"].Component);
var StyledFlex = _styledComponents["default"].div.withConfig({
  displayName: "Default__StyledFlex",
  componentId: "sc-1rkhdd9-0"
})(["display:flex;align-items:center;"]);
var StyledCaller = (0, _styledComponents["default"])(_RecentCalls["default"]).withConfig({
  displayName: "Default__StyledCaller",
  componentId: "sc-1rkhdd9-1"
})(["display:flex;"]);
var StyledDefaultState = (0, _styledComponents["default"])(StyledFlex).withConfig({
  displayName: "Default__StyledDefaultState",
  componentId: "sc-1rkhdd9-2"
})(["height:100%;> * + *{margin-left:10px;}"]);
DefaultState.propTypes = {
  className: _propTypes["default"].string,
  state: _propTypes["default"].oneOf(Object.values(_States["default"])),
  onCall: _propTypes["default"].func,
  onListen: _propTypes["default"].func,
  onOperatorsToggle: _propTypes["default"].func,
  onRecentCallsToggle: _propTypes["default"].func,
  calls: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    number: _propTypes["default"].number.isRequire
  })),
  operators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    call: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      duration: _propTypes["default"].number,
      state: _propTypes["default"].string
    }),
    contact: _propTypes["default"].shape({
      name: _propTypes["default"].string,
      number: _propTypes["default"].number,
      isHidden: _propTypes["default"].bool
    }),
    operator: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      number: _propTypes["default"].string.isRequired,
      skillGroups: _propTypes["default"].arrayOf(_propTypes["default"].string),
      canCall: _propTypes["default"].bool.isRequired,
      canTransfer: _propTypes["default"].bool.isRequired,
      canListen: _propTypes["default"].bool.isRequired,
      canRequestHelp: _propTypes["default"].bool.isRequired
    }).isRequired
  }))
};
DefaultState.defaultProps = {
  className: '',
  state: _States["default"].OFFLINE,
  onCall: Function.prototype,
  onListen: Function.prototype,
  onOperatorsToggle: Function.prototype,
  onRecentCallsToggle: Function.prototype,
  calls: null,
  operators: null
};
var _default = exports["default"] = DefaultState;